import * as types from '../mutation-types'
import { tempTransactionStatus } from '@/helpers/enums'

export default {
	namespaced: true,
	state: {
		transactions: [],
		transactionsJournal: [],
		tempTransactions: []
	},

	actions: {
		fetchAll({ commit }) {
			return window.axios.get('/materialTransactions/selfTransactionsSummary')
				.then((response) => {
					commit(types.STORE_TRANSACTIONS_SUMMARY, response.data);
					return response.data;
				});
		},

		fetchJournal({ commit }) {
			return window.axios.get('/MaterialTransactions/TransactionsJournal')
				.then((response) => {
					commit(types.STORE_TRANSACTIONS_JOURNAL, response.data);
					return response.data;
				});
		},

		fetchTempTransactions({ commit, rootState }) {
			return window.axios.get('/materialTransactions/tempTransaction', {
				params: {
					ToAccountIds: [rootState.auth.userData.accountId],
					TempTransactionStatus: [tempTransactionStatus.pending]
				}
			})
				.then((response) => {
					commit(types.STORE_TEMP_TRANSACTIONS, response.data);
					return response.data;
				});
		},

		acceptTempTransaction({ dispatch }, { id }) {
			return window.axios.post(`/materialTransactions/tempTransaction/${id}/Accept`)
				.then((response) => {
					return dispatch('fetchTempTransactions').then(() => response.data);
				});
		},

		reset({ commit }) {
			commit(types.RESET_TRANSACTIONS_SUMMARY);
		},

		resetJournal({ commit }) {
			commit(types.RESET_TRANSACTIONS_JOURNAL);
		},

		resetTempTransactions({ commit }) {
			commit(types.RESET_TEMP_TRANSACTIONS);
		}
	},

	mutations: {
		[types.STORE_TRANSACTIONS_SUMMARY](state, transactions) {
			state.transactions = transactions.sort(function(a, b) {
				if (a.name < b.name) {
					return -1
				};
				if (a.name > b.name) {
					return 1
				};
				return 0
			});
		},

		[types.STORE_TRANSACTIONS_JOURNAL](state, transactionsJournal) {
			state.transactionsJournal = Array.isArray(transactionsJournal) ? transactionsJournal : [];
		},

		[types.STORE_TEMP_TRANSACTIONS](state, tempTransactions) {
			state.tempTransactions = Array.isArray(tempTransactions) ? tempTransactions : [];
		},

		[types.RESET_TRANSACTIONS_SUMMARY](state) {
			state.transactions = [];
		},

		[types.RESET_TRANSACTIONS_JOURNAL](state) {
			state.transactionsJournal = [];
		},

		[types.RESET_TEMP_TRANSACTIONS](state) {
			state.tempTransactions = [];
		},
	},

	getters: {
		getTransactionById: state => id => state.transactions.find(c => c.id === id),
		getJournalTransactionById: state => id => state.transactionsJournal.find(c => c.id === id),

		getMaterialRemainingAmount: state => materialId => {
			const transaction = state.transactions.find(c => c.materialId === materialId);
			const amount = transaction?.remaining?.amount;
			return typeof amount === 'number' && amount >= 0 ? amount : 0;
		},

		/*
			مجموع الكميات التي تطالب بها كل العناصر الموجودة حالياً في طابور المزامنة (idb.objects.syncQueue
			عبر sync.js) - سواء pending أو error، فالعنصر الفاشل لم يُزامَن بعد ويبقى شاغلاً لحصته حتى
			يحذفه المندوب يدوياً من SyncQueueDialog
		*/
		getPendingClaimedAmount: (state, getters, rootState) => materialId =>
			rootState.sync.queue.reduce((sum, item) => {
				const claimed = (item.visitPayload.materialAmounts || []).find(m => m.materialId === materialId);
				return sum + (claimed ? claimed.amount : 0);
			}, 0),

		getAdjustedRemainingAmount: (state, getters) => materialId =>
			getters.getMaterialRemainingAmount(materialId) - getters.getPendingClaimedAmount(materialId)
	}
}
